import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';

import { environment } from '../../../environments/environment';

function isMsalGuardEnabled(): boolean {
  return environment.USE_CONNECT_PLATFORM && environment.cloudConnected;
}

export const msalCanActivateGuard: CanActivateFn = (route, state) => isMsalGuardEnabled()
  ? inject(MsalGuard).canActivate(route, state)
  : true;

export const msalCanActivateChildGuard: CanActivateChildFn = (route, state) => isMsalGuardEnabled()
  ? inject(MsalGuard).canActivateChild(route, state)
  : true;
